<section class="restricted-countries-page min90height restricted-countries-page--{{project}}">
  <div class="container">

    <h1 class="restricted-countries-page__title">IMPORTANT UPDATE</h1>
    <div class="restricted-countries-page__text"> 
      <p> We apologize, but {{brandName}} is currently unavailable in your country. </p>
      <p>Due to regulatory restrictions, {{brandName}} cannot be accessed from your location.</p>
      <p>If you are traveling in a country where our service is unavailable, you won't be able to access our services until you return to a supported location.</p>
    </div>
    <div class="restricted-countries-page__img">
      <img src="/assets/images/restricted-countries.svg">
    </div>
   
  </div>
</section>